import React, { ChangeEvent, InputHTMLAttributes } from 'react';

import styles from './styles.module.css';

export interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  setSelected: (value: string) => void;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Radio: React.FC<RadioProps> = ({
  id,
  setSelected,
  onChange,
  ...props
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSelected(e.target.value);
    onChange?.(e);
  };

  return (
    <label htmlFor={id} className={styles.radio}>
      <input id={id} type="radio" onChange={handleChange} {...props} />
    </label>
  );
};
